import React, { useState, useEffect, useCallback } from 'react';
import VspList from '../components/VspTable';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from "../apiBase";
import { Link } from 'react-router-dom';
import { ownerSecretHeader } from '../ownerSecret';

// safety lock
const ADMIN_MODE = false;    // change to false to lock

function VspPage({ setVspToEdit, currentAircraft }) {
    const [vsp, setVsps] = useState([]);
    const [msg, setMsg] = useState('');
    const navigate = useNavigate();
    const tail = (currentAircraft?.tailNumber || "").trim().toUpperCase();

    const protectedAircraft = [
        //"N6727N",
        //"N7117V", 
        //"N988BG",
    ];

    const isProtectedAircraft = protectedAircraft.includes(tail);
    const canEditVspeed = ADMIN_MODE || !isProtectedAircraft;
      
    console.log("VSP LOCK CHECK:", {
    tail,
    ADMIN_MODE,
    protectedAircraft,
    isProtectedAircraft,
    canEditVspeed
    });

    const onDelete = async (id) => {
        try {
            const response = await fetch(
                `${API_BASE}/api/vspeeds?tail=${encodeURIComponent(tail)}&id=${encodeURIComponent(id)}`,
                { method: 'DELETE',
                headers: ownerSecretHeader(tail)
                }
            );

            if (response.status === 204) {
                setVsps((prev) => prev.filter((m) => (m.id ?? m._id) !== id));
            } else {
                console.error(`Failed to delete vspeed with id = ${id}, status code = ${response.status}`);
            }
        } catch (error) {
            console.error(`Error deleting vspeed with id = ${id}:`, error);
        }
    };

    const onEdit = (row) => {
        setVspToEdit(row);
        const rowId = row?.id ?? row?._id ?? "";
        navigate(`/edit-vsp/${encodeURIComponent(rowId)}`);
    };

    const loadVsp = useCallback(async () => {
        if (!tail) {
            setMsg('No aircraft selected');
            setVsps([]);
            return;
        }

        try {
            setMsg(`Loading ${tail}...`);

            const response = await fetch(
                `${API_BASE}/api/vspeeds?tail=${encodeURIComponent(tail)}`
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log("Vspeed response full =", data);

            const rows = Array.isArray(data?.vspeeds) ? data.vspeeds : [];

            const normalized = rows.map((r) => ({
                ...r,
                id: r.id ?? r.item ?? r.name ?? "",
                name: r.name ?? r.item ?? "",
                config: r.config ?? "",
                vs1: r.vs1 ?? r.vsp1 ?? "",
                vs2: r.vs2 ?? r.vsp2 ?? "",
                units: r.units ?? ""
            }));

            setVsps(normalized);
            setMsg(`${tail} loaded`);
        } catch (error) {
            console.error('Failed to load vspeeds:', error);
            setMsg('Failed to load vspeeds');
            setVsps([]);
        }
    }, [tail]);

    useEffect(() => {
        loadVsp();
    }, [loadVsp]);

    return (
        <article className="App-article">
            {/* ============================================================
                RELATED TOOLS / INTERNAL LINKS
                ============================================================ */}
                  
                <div className="related-links">
                    <Link to="/density-altitude">Density Altitude</Link> |
                    <Link to="/cw">Crosswind/Headwind</Link> |
                    <Link to="/mnvr">Maneuvers</Link> |
                    <Link to="/airplane-prebuy">Airplane Prebuy Checklist</Link> |
                    <Link to="/adjustable-amortization">Aircraft Loan</Link>
                </div>
                <br/>
            <h2>Vspeeds</h2>
            <div>{msg}</div>


            <div style={{ marginBottom: "10px" }}>
                <button
                    onClick={() => navigate(`/add-vspeed?tail=${encodeURIComponent(tail)}`)}
                >
                    Add Vspeed
                </button>
            </div>

            <VspList
                vsp={vsp}
                msg={msg}
                onDelete={onDelete}
                onEdit={onEdit}
                canEdit={canEditVspeed }
            />

             {/* ============================================================
                OPTIONAL AD PLACEMENT
                ============================================================ */}
                <div className="ad-banner">
                    Ad Space
                </div>
            
            {/* ============================================================
                RELATED TOOLS / INTERNAL LINKS
                ============================================================ */}
                <div className="tool-content">
                <h2 >Related Tools</h2>
                  
                <p >
                    <Link to="/vsps">Vspeed</Link> |
                    <Link to="/rollout">Ground Roll</Link> |
                    <Link to="/navlog">NavLog</Link> |
                    <Link to="/wtbals">Weight & Balance</Link> |
                    <Link to="/density-altitude">Density Altitude</Link> |
                    <Link to="/cw">Crosswind/Headwind</Link> |
                    <Link to="/mnvr">Maneuvers</Link> |
                    <Link to="/airframe-powerplant">Airframe & Powerplant</Link> |
                    <Link to="/airplane-prebuy">Airplane Prebuy Checklist</Link> |
                    <Link to="/adjustable-amortization">Aircraft Loan</Link>
                    </p>
                    </div>
        </article>
    );
}

export default VspPage;